/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-12-19 15:06:55
 * @FilePath: \monitor\src\language\project\project.js
 * @Description: 
 */
const info = {
  CN: {
    newProject: "新建项目",
    editProject: "编辑项目",
    cancelBtn: "取消",
    saveBtn: "保存",
    number: "序号",
    projectName: "项目名称",
    projectDescription: "项目描述",
    projectStatus: "项目状态",
    contacts: "联系人",
    phone: "电话号码",
    createTime: "创建时间",
    operation: "操作",
    inOperation: "运行中",
    suspend: "暂停",
    accessible: "可访问",
    cease: "停止",
    edit: "编辑",
    delete: "删除",
    tips: "温馨提示",
    deleteTips: "删除操作不可恢复,是否继续删除该项目？",
    deleteImageTips: "删除操作不可恢复,是否继续删除该平面图？",
    deleteSuccess: "删除成功",
    deleteError: "删除失败",
    validWarnText: "必填信息不能为空",
    addSuccess: "添加成功",
    addError: "添加失败",
    saveSuccess: "保存成功",
    saveError: "保存失败",
    imageBtn: "平面图",
    closeBtn: "关闭",
    
  },
  EN: {
    newProject: "New Project",
    editProject: "Edit Project",
    cancelBtn: "Cancel",
    saveBtn: "Save",
    number: "Number",
    projectName: "Project Name",
    projectDescription: "Project Description",
    projectStatus: "Project Status",
    contacts: "Contacts",
    phone: "Phone",
    createTime: "Create Time",
    operation: "Operations",
    inOperation: "in operation",
    suspend: "suspend",
    accessible: "accessible",
    cease: "stop",
    edit: "edit",
    delete: "delete",
    tips: "Tips",
    deleteTips: "The deletion operation is irreversible. Do you want to continue deleting this item?",
    deleteImageTips: "The deletion operation is irreversible. Do you want to continue deleting the floor plan?",
    deleteSuccess: "Successfully deleted",
    deleteError: "Delete failed",
    validWarnText: "Required information cannot be empty",
    addSuccess: "Added successfully",
    addError: "Add failed",
    saveSuccess: "Successfully saved",
    saveError: "Save failed",
    imageBtn: "plan view",
    closeBtn: "close",

  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/project/project.js